import React from "react";
import styles from "./styles.module.scss";
import { Spacing } from "spacing/component";
import closeSrc from "../../assets/svgs/close-24px.svg";
import IDialogProps from "./types/index";
import { TitleFont } from "../fonts";
export const DialogVW = ({
  children,
  title,
  className,
  onClose
}: IDialogProps) => (
  <div className={styles.root}>
    <Spacing
      className={`${className} ${styles.content}`}
      ph="xs"
      pb="s"
      pt="xl"
    >
      <img
        className={styles.close}
        onClick={() => onClose && onClose()}
        src={closeSrc}
        alt="close"
      />
      {title && <TitleFont>{title!}</TitleFont>}
      <div className={styles.children}>{children}</div>
      <Spacing pt="2xl" />
    </Spacing>
  </div>
);
